import React from 'react';
import clsx from 'clsx';
import { IProps } from './OptimizelyForm.interface';
import './OptimizelyForm.styles.css';
import { Base64HtmlRenderer } from '@/components/Base64HtmlRenderer/Base64HtmlRenderer.component';

export const OptimizelyForm: React.FC<IProps> = ({
  className,
  form
}) => {
  return (
    <>
      {form && (
        <div
          className={clsx("optimizelyForm__form-container", className)}
        >
          <Base64HtmlRenderer content={form} base64Encoded={true} />
        </div>
      )}
    </>
  );
};
